/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { AbpPtwExceptionHttpResponseModelData } from './AbpPtwExceptionHttpResponseModelData';
import {
    AbpPtwExceptionHttpResponseModelDataFromJSON,
    AbpPtwExceptionHttpResponseModelDataFromJSONTyped,
    AbpPtwExceptionHttpResponseModelDataToJSON,
} from './AbpPtwExceptionHttpResponseModelData';
import type { I18nInfo } from './I18nInfo';
import {
    I18nInfoFromJSON,
    I18nInfoFromJSONTyped,
    I18nInfoToJSON,
} from './I18nInfo';
import type { CsoPortalErrorDto } from './CsoPortalErrorDto';
import {
    CsoPortalErrorDtoFromJSON,
    CsoPortalErrorDtoFromJSONTyped,
    CsoPortalErrorDtoToJSON,
} from './CsoPortalErrorDto';
import type { Exception } from './Exception';
import {
    ExceptionFromJSON,
    ExceptionFromJSONTyped,
    ExceptionToJSON,
} from './Exception';

/**
 * 
 * @export
 * @interface Ptw100CsoPortalBadGatewayException
 */
export interface Ptw100CsoPortalBadGatewayException {
    /**
     * 
     * @type {string}
     * @memberof Ptw100CsoPortalBadGatewayException
     */
    readonly targetSite?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Ptw100CsoPortalBadGatewayException
     */
    readonly message?: string | null;
    /**
     * 
     * @type {AbpPtwExceptionHttpResponseModelData}
     * @memberof Ptw100CsoPortalBadGatewayException
     */
    data?: AbpPtwExceptionHttpResponseModelData | null;
    /**
     * 
     * @type {Exception}
     * @memberof Ptw100CsoPortalBadGatewayException
     */
    innerException?: Exception;
    /**
     * 
     * @type {string}
     * @memberof Ptw100CsoPortalBadGatewayException
     */
    helpLink?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Ptw100CsoPortalBadGatewayException
     */
    source?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Ptw100CsoPortalBadGatewayException
     */
    hResult?: number;
    /**
     * 
     * @type {string}
     * @memberof Ptw100CsoPortalBadGatewayException
     */
    readonly stackTrace?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Ptw100CsoPortalBadGatewayException
     */
    code?: number;
    /**
     * 
     * @type {I18nInfo}
     * @memberof Ptw100CsoPortalBadGatewayException
     */
    i18n?: I18nInfo;
    /**
     * 
     * @type {CsoPortalErrorDto}
     * @memberof Ptw100CsoPortalBadGatewayException
     */
    remedy?: CsoPortalErrorDto;
    /**
     * 
     * @type {string}
     * @memberof Ptw100CsoPortalBadGatewayException
     */
    $type?: Ptw100CsoPortalBadGatewayExceptionTypeEnum;
}


/**
 * @export
 */
export const Ptw100CsoPortalBadGatewayExceptionTypeEnum = {
    PtwPtw100AppZeroApplicationSharedExceptionsPtw100CsoPortalBadGatewayExceptionPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Exceptions.Ptw100CsoPortalBadGatewayException, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type Ptw100CsoPortalBadGatewayExceptionTypeEnum = typeof Ptw100CsoPortalBadGatewayExceptionTypeEnum[keyof typeof Ptw100CsoPortalBadGatewayExceptionTypeEnum];



/**
 * Check if a given object implements the Ptw100CsoPortalBadGatewayException interface.
 */
export function instanceOfPtw100CsoPortalBadGatewayException(value?: unknown): value is Ptw100CsoPortalBadGatewayException {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(Ptw100CsoPortalBadGatewayExceptionTypeEnum)[0];
}

export function Ptw100CsoPortalBadGatewayExceptionFromJSON(json: any): Ptw100CsoPortalBadGatewayException {
    return Ptw100CsoPortalBadGatewayExceptionFromJSONTyped(json, false);
}

export function Ptw100CsoPortalBadGatewayExceptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Ptw100CsoPortalBadGatewayException {
    if (json == null) {
        return json;
    }
    return {
        
        'targetSite': json['targetSite'] == null ? undefined : json['targetSite'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : AbpPtwExceptionHttpResponseModelDataFromJSON(json['data']),
        'innerException': json['innerException'] == null ? undefined : ExceptionFromJSON(json['innerException']),
        'helpLink': json['helpLink'] == null ? undefined : json['helpLink'],
        'source': json['source'] == null ? undefined : json['source'],
        'hResult': json['hResult'] == null ? undefined : json['hResult'],
        'stackTrace': json['stackTrace'] == null ? undefined : json['stackTrace'],
        'code': json['code'] == null ? undefined : json['code'],
        'i18n': json['i18n'] == null ? undefined : I18nInfoFromJSON(json['i18n']),
        'remedy': json['remedy'] == null ? undefined : CsoPortalErrorDtoFromJSON(json['remedy']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function Ptw100CsoPortalBadGatewayExceptionToJSON(value?: Omit<Ptw100CsoPortalBadGatewayException, 'targetSite'|'message'|'stackTrace'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'data': AbpPtwExceptionHttpResponseModelDataToJSON(value['data']),
        'innerException': ExceptionToJSON(value['innerException']),
        'helpLink': value['helpLink'],
        'source': value['source'],
        'hResult': value['hResult'],
        'code': value['code'],
        'i18n': I18nInfoToJSON(value['i18n']),
        'remedy': CsoPortalErrorDtoToJSON(value['remedy']),
        '$type': value['$type'],
    });
}

